module.exports = __webpack_public_path__ + "img/phone.c2604155.svg";